module.exports = __webpack_public_path__ + "img/planning-success.554b10cf.png";